<div class="latest-meeting-card">

  <div class="dates-container">
    <div class="dates-wrap">
      <span class="icon-Calendar-2"></span>
      <div class="date from">{{ HELPER.formatDateWithLocalizedMonth(from()) }}</div>
      <span class="dash"> - </span>
      <div class="date to">{{ HELPER.formatDateWithLocalizedMonth(to()) }}</div>
    </div>
  </div>
  <div class="title">{{ title() }}</div>
  <div [innerHTML]="description() | removeHtml" class="description"></div>
</div>
